import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KryptomonMigrateComponent } from './kryptomon-migrate.component';
import { DialogModule } from 'primeng/dialog';
import { TranslocoModule } from '@ngneat/transloco';
import { KKryptomonCardModule } from 'app/common/ui/k-cards/k-kryptomon-card/k-kryptomon-card.module'
import { ChartModule } from 'primeng/chart';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { DirectivesModule } from 'app/common/directives/directives.module'
import { PackageBuyModalModule } from 'app/common/components/package-buy-modal/package-buy-modal.module'

@NgModule({
  declarations: [
    KryptomonMigrateComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    TranslocoModule,
    KKryptomonCardModule,
    ChartModule,
    KButtonModule,
    DirectivesModule,
    PackageBuyModalModule
  ],
  exports: [
    KryptomonMigrateComponent
  ]
})
export class KryptomonMigrateModule { }
